<template>
  <div>
    <div class="d-flex justify-content-center mb-1">
      <b-spinner
        variant="success"
        span="Spinning"
        block
        v-if="loadingSpinner"
        style="width: 3rem; height: 3rem"
      ></b-spinner>
    </div>

    <section class="invoice-preview-wrapper" v-if="!loadingSpinner">
      <b-row class="invoice-preview">
        <!-- Col: Left (Invoice Container) -->
        <b-col cols="12" xl="9" md="8">
          <b-card
            no-body
            class="invoice-preview-card px-1"
            id="invoice-preview-card"
          >
            <b-card-body class="invoice-padding pb-0">
              <div class="row align-items-center mb-2">
                <div class="">
                  <Logo />
                </div>
                <div class="col-9">
                  <div class="">
                    <CompanyName />
                  </div>
                  <div class="">
                    <Address />
                  </div>
                </div>
              </div>
              <b-card-body class="invoice-padding pt-0">
                <div class="row">
                  <div class="col-6">
                    <div class="invoice-spacing">
                      <div>
                        <h6 class="mb-2">Supplier</h6>

                        <CompanyAddress :supplier="supplierId" />
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="invoice-number-date mt-md-0 mt-2">
                      <div
                        class="d-flex align-items-center justify-content-md-end mb-1"
                      >
                        <h4>
                          {{ this.headerName }} #{{
                            purchaseorderId.orderNumber
                          }}
                        </h4>
                      </div>
                      <div class="d-flex align-items-center my-2">
                        <span class="title"> Issued Date: </span>
                        <flat-pickr
                          v-model="purchaseorderId.issueDate"
                          class="form-control invoice-edit-input"
                          disabled
                        />
                      </div>
                      <div class="d-flex align-items-center">
                        <span class="title"> Due Date: </span>
                        <flat-pickr
                          v-model="purchaseorderId.dueDate"
                          class="form-control invoice-edit-input"
                          disabled
                        />
                      </div>

                      <div
                        v-if="this.vat"
                        class="d-flex align-items-center my-2"
                      >
                        <span class="title me-2">VAT:</span>
                        <p class="invoice-date mb-0">{{ this.vat }}</p>
                      </div>

                      <div class="d-flex align-items-center my-2" v-if="this.vat">
                        <span class="title me-2">BRN Number:</span>
                        <p class="invoice-date mb-0">{{ this.brn }}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0"
                >
                  <!-- Header: Right Content -->
                </div>
              </b-card-body>
            </b-card-body>

            <!-- Spacer -->
            <hr class="invoice-spacing" />

            <!-- Invoice Description: Table -->
            <b-table
              responsive
              :fields="dynamicFields"
              :items="purchaseorderId.purchaseOrderItems"
            >
              <template #cell(itemId)="data">
                {{ getItemName(data.item.itemId) }}
              </template>
              <template #cell(cost)="data">
                Rs {{ data.item.cost.toFixed(2) }}
              </template>

              <template #cell(qty)="data">
                {{ parseFloat(data.item.quantity).toFixed(2) }}
              </template>

              <template #cell(VAT)="data">
                {{
                  data.item.saleTaxPercentage
                    ? parseFloat(data.item.saleTaxPercentage).toFixed(2)
                    : 0
                }}
                %
              </template>

              <template #cell(price)="data">
                Rs {{ (data.item.cost * data.item.quantity).toFixed(2) }}
              </template>
            </b-table>

            <!-- Invoice Description: Total -->
            <b-card-body class="invoice-padding pb-0">
              <b-row>
                <!-- Col: Sales Persion -->
                <b-col
                  cols="12"
                  md="6"
                  class="mt-md-0 mt-3"
                  order="2"
                  order-md="1"
                >
                  <b-card-text class="mb-0">
                    <span class="font-weight-bold">Salesperson :</span>
                    <span class="ml-75"
                      >{{ purchaseorderId.salesPersonId }}
                    </span>
                  </b-card-text>
                </b-col>

                <!-- Col: Total -->
                <b-col
                  cols="12"
                  md="6"
                  class="mt-md-6 d-flex justify-content-end"
                  order="1"
                  order-md="2"
                >
                  <div
                    class="invoice-total-wrapper"
                    v-if="!this.purchaseorderId.hidePrice"
                  >
                    <hr class="my-50" />
                    <div class="invoice-total-item">
                      <p class="invoice-total-title">Total:</p>
                      <p
                        class="invoice-total-amount"
                        v-if="purchaseorderId.total"
                      >
                        Rs {{ purchaseorderId.total.toFixed(2) }}
                      </p>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-card-body>

            <!-- Spacer -->
            <hr class="invoice-spacing" />

            <!-- Note -->
            <b-card-body class="invoice-padding pt-0">
              <span class="font-weight-bold">Note: </span>
              <span>{{ purchaseorderId.note }}</span>
            </b-card-body>
          </b-card>
        </b-col>

        <!-- Right Col: Card -->
        <b-col cols="12" md="4" xl="3" class="invoice-actions">
          <b-card>
            <!-- Button: DOwnload -->

            <!-- Button: Print -->
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              class="mb-75"
              block
              @click="printQuotation"
            >
              Print / Download
            </b-button>

            <b-button
              v-if="supplierId.phoneNumber && tenant"
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="info"
              class="mb-75"
              @click="openWhatsApp"
              block
            >
              <img src="@/assets/images/logo/whatsapp.png" class="w-10" />
              Whatsapp
            </b-button>

            <b-button
              v-if="canConvert"
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              class="mb-75"
              block
              @click="convertPO(purchaseorderId)"
            >
              Convert
            </b-button>

            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              class="mb-75"
              block
              @click="viewPurchaseOrderDocuments(id)"
            >
              Documents
            </b-button>

            <b-modal
              ref="modal-view-purchase-order-document"
              id="modal-view-purchase-order-document"
              ok-only
              ok-title="View"
              centered
              size="lg"
              title="View Purchase Order Documents"
              :hide-footer="true"
            >
              <DocumentUpload
                @deleteFile="deleteFile"
                @downloadFile="downloadFile"
                @uploadFiles="uploadFiles"
                :documentDetails="documentDetails"
              />
            </b-modal>
          </b-card>
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BTable,
  BButton,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BFormTextarea,
  BFormCheckbox,
  BPopover,
  VBToggle,
  BLink,
  BFormSelect,
  BSpinner,
} from "bootstrap-vue";
import Logo from "@core/layouts/components/Logo.vue";
import Ripple from "vue-ripple-directive";
import flatPickr from "vue-flatpickr-component";
import DocumentUpload from "@/views/component/DocumentUpload.vue";
import {
  deletePurchaseOrderDocument,
  uploadPurchaseOrderMultipleDocuments,
  uploadPurchaseOrderDocument,
  downloadPurchaseOrderDocument,
} from "@/store/purchaseorder/services";
import {
  customSwal,
  customError,
  customLoader,
  fnSortingDropdown,
} from "@/libs/customFn";

import Address from "@core/layouts/components/Address.vue";
import CompanyName from "@core/layouts/components/CompanyName.vue";
import CompanyAddress from "@/@core/layouts/components/CompanyAddress.vue";

import { mapActions, mapGetters } from "vuex";
import item from "@/store/item";

export default {
  directives: {
    Ripple,
    "b-toggle": VBToggle,
  },
  components: {
    flatPickr,
    BRow,
    BCol,
    BTable,
    BCard,
    BCardBody,
    BButton,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BFormTextarea,
    BFormCheckbox,
    BPopover,
    VBToggle,
    BFormSelect,
    Logo,
    BSpinner,
    BTable,
    BLink,
    DocumentUpload,
    Address,
    CompanyName,
    CompanyAddress,
  },
  data() {
    return {
      id: this.$route.params.id,
      tenant: localStorage.getItem("userTenant"),
      companyName: localStorage.getItem("userTenant"),
      vat: JSON.parse(localStorage.getItem("userData")).vat,
      brn: JSON.parse(localStorage.getItem("userData")).brn,
      loadingSpinner: false,
      leadClientId: "",
      salesPersonId: "",
      dueDate: "",
      subTotal: "",
      discount: "",
      tax: "",
      total: "",
      note: "",
      status: "",
      paymentMethod: "",
      quotationItems: {
        id: "",
        purchaseorderId: "",
        itemId: "",
        quantity: "",
        price: "",
        cost: "",
        isActive: "",
      },

      fields: [
        { key: "id", span: "ID", thClass: "d-none", tdClass: "d-none" }, //thClass and tdClass used to hide fields
        {
          key: "purchaseorderId",
          span: "QUOTATION_ID",
          thClass: "d-none",
          tdClass: "d-none",
        },
        { key: "itemId", span: "Item Name" },

        { key: "quantity", span: "QUANTITY" },
      ],
      warehouseName: "",
      documentDetails: {
        isDelete: false,
        documentList: [],
      },
      hasConvertedToPurchaseInvoice: false,
      documentDetails: {
        isDelete: false,
        documentList: [],
      },
      PoId: "",
    };
  },
  computed: {
    dynamicFields() {
      const dynamicFields = [...this.fields];
      if (!this.purchaseorderId.hidePrice) {
        dynamicFields.push({ key: "cost", span: "Unit Price (Rs)" });
        dynamicFields.push({ key: "price", span: "Total Price (Rs)" });
      }
      return dynamicFields;
    },
    headerName() {
      const dynamicFields = [...this.fields];
      if (this.purchaseorderId.hidePrice) {
        return "RFP";
      }
      return "Purchase Order";
    },

    ...mapGetters("purchaseOrderModule", {
      purchaseOrderList: "purchaseorders",
      purchaseorderId: "purchaseorderId",
      loading: "loading",
      documents: "documents",
      file: "file",
    }),
    ...mapGetters("supplierModule", {
      supplierId: "supplierId",
      loading: "loading",
    }),
    ...mapGetters("salesPersonModule", {
      SalesPersonList: "salesperson",
      loading: "loading",
    }),
    ...mapGetters("productModule", {
      productList: "product",
      loading: "loading",
    }),
    ...mapGetters("rawmaterialModule", {
      materials: "rawmaterials",
      loading: "loading",
    }),
    ...mapGetters("warehouseModule", {
      warehouses: "warehouse",
      warehouseLoading: "loading",
    }),
    canConvert() {
      // Assuming 'hasConvertedToPurchaseInvoice' is a flag in your purchaseorderId object
      return (
        this.purchaseorderId &&
        !this.purchaseorderId.hasConvertedToPurchaseInvoice
      );
    },
  },
  methods: {
    convertPO(item) {
      console.log("Item passed to convertPO:", item);
      if (!item || !item.id) {
        console.error("Error: Item ID is undefined.");
        return;
      }

      try {
        this.$router.push({
          name: "purchaseinvoice-edit",
          query: { PoID: item.id },
        });
      } catch (error) {
        this.$swal({
          title: "Error!",
          text: "There was an error navigating to the Purchase Invoice creation page.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      }
    },

    async viewPurchaseOrderDocuments(referenceId) {
      try {
        this.PoId = referenceId;
        console.log("referenceId", referenceId);
        console.log("PoId", this.PoId);
        await this.getPurchaseOrderDocumentListAction(referenceId);
        if (this.documents.length > 0) {
          this.documentDetails.documentList = this.documents;
          this.documentDetails.isDelete = true;
        }
        this.$refs["modal-view-purchase-order-document"].show();
      } catch (error) {
        console.error("Error fetching documents:", error);
      }
    },

    async downloadFile(downloadById, fileName) {
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document is being prepared for download",
        onOpen: () => {
          loader.showLoading();
        },
        allowOutsideClick: () => !loader.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });

      try {
        const response = await downloadPurchaseOrderDocument(downloadById);
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type:
              response.headers["content-type"] || "application/octet-stream",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName); // Use the provided fileName parameter directly
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Clean up DOM by removing the link element after clicking
        window.URL.revokeObjectURL(url); // Free up memory by releasing object URL

        loader.close();
      } catch (error) {
        console.error("Download failed:", error);
        loader.close();
        this.error("Failed to download the file. Please try again."); // Updated error message for better clarity
      }
    },

    async uploadFiles(selectedFiles) {
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document(s) is being added",
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });
      const referenceId = this.PoId;

      const maxSize = 20 * 1024 * 1024;
      if (this.selectedFiles && this.selectedFiles.size > maxSize) {
        alert("File size exceeds 20 MB limit. Please choose a smaller file.");
        this.submitting = false;
        return;
      }

      if (selectedFiles.length > 1) {
        await uploadPurchaseOrderMultipleDocuments(selectedFiles, referenceId)
          .then((response) => {
            setTimeout(() => {
              this.$swal.close();
            }, 3000);
            customSwal("Your file(s) have been successfully uploaded.");
            loader.close();
          })
          .catch((error) => {
            customError(error);
            loader.close();
          });
      } else if (selectedFiles.length < 2) {
        await uploadPurchaseOrderDocument(selectedFiles, referenceId)
          .then((response) => {
            setTimeout(() => {
              this.$swal.close();
            }, 3000);
            customSwal("Your file(s) have been successfully uploaded.");
            loader.close();
          })
          .catch((error) => {
            customError(error);
            loader.close();
          });
      }

      await this.getPurchaseOrderDocumentListAction(referenceId);
      this.documentDetails.documentList = this.documents;
      this.documentDetails.isDelete = true;

      this.$nextTick(() => {
        this.$bvModal.show("modal-view-purchase-order-document");
      });
    },
    async deleteFile(deleteById) {
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document is being deleted",
        allowEscapeKey: false,
        allowOutsideClick: false,
        buttonsStyling: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      await deletePurchaseOrderDocument(deleteById)
        .then((response) => {
          loader.close();
          customSwal("File deleted successfully!");
        })
        .catch((error) => {
          loader.close();
          customError(error);
        });

      await this.getPurchaseOrderDocumentListAction(this.PoId);
      this.documentDetails.documentList = this.documents;

      this.$nextTick(() => {
        this.$bvModal.show("modal-view-purchase-order-document");
      });
    },

    printQuotation() {
      window.print();
    },

    openWhatsApp() {
      const message = `Please find attached the Purchase order issued from ${this.companyName}. ${process.env.VUE_APP_CRM_URL}purchaseOrder/${this.tenant}/${this.id}`;
      const url = `https://web.whatsapp.com/send/?phone=${this.supplierId.phoneNumber}&text=${message}&type=phone_number`;
      window.open(url, "_blank");
    },

    getItemName(id) {
      const product = this.productList.find((x) => x.id == id);
      if (product && product.name) {
        return product.name;
      } else {
        const material = this.materials.find((x) => x.id == id);
        if (material && material.name) {
          console.log(material);
          return material.name;
        }
      }
      return "";
    },
    ...mapActions("supplierModule", [
      "getSupplierByIDAction",
      "getSupplierListAction",
    ]),
    ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),
    ...mapActions("purchaseOrderModule", [
      "getPurchaseOrdersByIDAction",
      "getPurchaseOrdersListAction",
      "removePurchaseOrdersAction",
      "updatePurchaseOrdersAction",
      "getPurchaseOrderDocumentListAction",
    ]),
    ...mapActions("productModule", ["getProductListAction"]),
    ...mapActions("rawmaterialModule", ["getRawMaterialListAction"]),
    ...mapActions("warehouseModule", ["getWarehouseListAction"]),

    downloadPDF() {
      var opt = {
        margin: [0, 0],
        filename: "quotation.pdf",
        image: { type: "jpeg", quality: 1 },
        html2canvas: { scale: 2, allowTaint: true },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      };
      var element = document.getElementById("invoice-preview-card");
      var elementHtml = element.outerHTML;
      html2pdf().from(elementHtml).set(opt).save();
    },
  },

  getPurchaseOrderId(item) {
    return "/purchaseorder/view/" + item;
  },

  async mounted() {
    this.loadingSpinner = true; // Set to true when the component is mounted
    setTimeout(() => {
      this.loadingSpinner = false; // Set to false after 4 seconds
    }, 6000);

    await this.getProductListAction();
    await this.getRawMaterialListAction();
    await this.getPurchaseOrdersByIDAction(this.id)
      .then(() => {
        console.log(this.purchaseorderId);

        this.getSupplierByIDAction(this.purchaseorderId.supplierId);
        this.getSalesPersonListAction().then(() => {
          this.SalesPersonList.forEach((element) => {
            if (element.id == this.purchaseorderId.salesPersonId) {
              this.purchaseorderId.salesPersonId =
                element.firstName + " " + element.lastName;
            }
          });
        });
      })
      .catch((response) => {
        console.log(response);
      });

    await this.getWarehouseListAction().then(() => {
      let warehouse = this.warehouses.filter(
        (v, i) => v.id == this.purchaseorderId.warehouseId
      );
      this.warehouseName = warehouse[0].name ?? "";
    });
  },
};
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss">
@media print {
  a[href]:after {
    content: none !important;
  }

  html,
  body {
    height: 99% !important;
  }

  // Global Styles
  .invoice-date-title {
    color: black !important;
  }

  * {
    color: black !important;
  }

  body {
    background-color: transparent !important;
    font-size: 17.5px !important;
    color: black !important;
  }

  .flatpickr-input {
    font-size: 17.5px !important;
    color: black !important;
  }

  nav.header-navbar {
    display: none;
  }

  .main-menu {
    display: none;
  }

  .header-navbar-shadow {
    display: none !important;
  }

  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }

  footer.footer {
    display: none;
  }

  .card {
    background-color: transparent;
    box-shadow: none;
  }

  .customizer-toggle {
    display: none !important;
  }

  .content-header {
    display: none !important;
  }

  .invoice-edit-input {
    border: none;
  }

  // Invoice Specific Styles
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
            > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }
}
</style>
